import type { FC } from 'react';
import React from 'react';

import styled from '@emotion/styled';

import { mq } from '@clutter/clean';

import type { PageQuery } from '@graphql/platform';

import FALLBACK_HERO from '@images_responsive/locations/storage_hero.jpg';

import {
  HeroContainer,
  HeroContent,
  HeroHeadline,
  HeroImage,
  HeroImageColumn,
  HeroImageWrapper,
  HeroInner,
  HeroTextColumn,
} from '../shared/hero_layout';
import { PageCTA } from './cta';
import { PAGE_HERO_CTA_CONTAINER, PAGE_HERO_CTA_LABEL } from './shared';

const PageHeroTitle = styled(HeroHeadline)`
  text-wrap: balance;
  white-space: pre-line;
`;

const FullBleedImageColumn = styled(HeroImageColumn)`
  ${mq({
    marginLeft: ['-24px', undefined, undefined],
    marginRight: ['-24px', undefined, undefined],
    width: ['calc(100% + 48px)', undefined, undefined],
    height: ['auto', undefined, undefined],
  })}
`;

const FullBleedHeroImageWrapper = styled(HeroImageWrapper)`
  border-radius: 0;
  ${mq({
    borderRadius: [0, 'var(--S, 18px)', 'var(--S, 18px)'],
    maxWidth: ['100%', undefined, undefined],
  })}
`;

export const PageHero: FC<{
  page: PageQuery['page'];
}> = ({ page }) => {
  if (!page) throw new Error('missing page');

  const heroURL = page.hero?.imgixURL ?? null;
  const title = page.title.trim();

  return (
    <HeroContainer>
      <HeroInner>
        <HeroContent>
          <HeroTextColumn>
            <PageHeroTitle as="h1">{title}</PageHeroTitle>
            <PageCTA
              id="hero_cta"
              container={PAGE_HERO_CTA_CONTAINER}
              label={page.cta || PAGE_HERO_CTA_LABEL}
            />
          </HeroTextColumn>
          <FullBleedImageColumn>
            <FullBleedHeroImageWrapper>
              <HeroImage src={heroURL ?? FALLBACK_HERO.src} alt={page.title} />
            </FullBleedHeroImageWrapper>
          </FullBleedImageColumn>
        </HeroContent>
      </HeroInner>
    </HeroContainer>
  );
};
